import map from "../core/map";

const ControlType = {
    None: 0,
    TypeaHead: 1,
    MapToggle: 2,
    DialogOption: 3,
    ICheckBox: 4,
    ICheckRadio: 5,
    KendoButton: 6,
    KendoMobileButtonGroup: 7,
    KendoSlider: 8,
    GlobalEvent: 9,
    KendoDropDownList: 10,
    KendoDatePicker: 11,
    Input: 12,
    InputCheckbox: 13,
    InputButton: 14,
    KendoMultiselect: 15,
    MapView: 16
};

class Item {
    constructor(id, value, type, idMap = null) {
        this.idMap = idMap || map.getCurrentMapId();
        this.id = id;
        this.value = value;
        this.type = type;
    }

    toString() {
        return JSON.stringify(this);
    }
};

export {
    Item,
    ControlType
};



// WEBPACK FOOTER //
// ./src/scripts/workspaces/item.js